if (!customElements.get('bb-size-picker')) {
  customElements.define('bb-size-picker', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
      this.controller = new AbortController();
      this.sizeSelect = this.querySelector('[data-size-select]');
      this.cards = Array.from(this.querySelectorAll('[data-variant-card]'));
      this.titleOutput = this.querySelector('[data-selected-title]');
      this.priceOutput = this.querySelector('[data-selected-price]');
      this.orderLink = this.querySelector('[data-order-link]');
      this.unavailable = this.querySelector('[data-unavailable]');
      if (this.sizeSelect) this.sizeSelect.disabled = false;
      this.addEventListener('change', (event) => {
        if (event.target === this.sizeSelect) this.selectSize();
        else if (event.target.matches('input[type="radio"]')) this.updateSelection(event.target);
      }, { signal: this.controller.signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const main = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
          if (!data?.variant || data.sectionId !== main?.dataset.section) return;
          this.syncVariant(String(data.variant.id));
        });
      }
      this.selectSize();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.unsubscribe?.();
    }

    selectSize(preferredId) {
      const previous = this.querySelector('input[type="radio"]:checked');
      const currentSize = this.sizeSelect?.value || this.cards[0]?.dataset.size;
      const visibleInputs = [];
      for (const card of this.cards) {
        card.hidden = card.dataset.size !== currentSize;
        const input = card.querySelector('input');
        input.checked = false;
        if (!card.hidden) visibleInputs.push(input);
      }
      const selected = visibleInputs.find(input => input.value === preferredId && !input.disabled)
        || visibleInputs.find(input => input.dataset.finish === previous?.dataset.finish && !input.disabled)
        || visibleInputs.find(input => !input.disabled)
        || visibleInputs[0];
      if (selected) selected.checked = true;
      this.updateSelection(selected);
    }

    syncVariant(id) {
      const card = this.cards.find(item => item.querySelector('input').value === id);
      if (!card) return;
      if (this.sizeSelect) this.sizeSelect.value = card.dataset.size;
      this.selectSize(id);
    }

    updateSelection(input) {
      const available = input && !input.disabled;
      this.titleOutput.textContent = input?.dataset.title || '';
      this.priceOutput.textContent = input?.dataset.price || '';
      this.orderLink.hidden = !available;
      this.unavailable.hidden = Boolean(available);
      if (available) this.orderLink.href = input.dataset.url;
    }
  });
}
